
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iIst3", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bf7c6e3a03bd96$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $01bf7c6e3a03bd96$var$AsyncLazyServiceEntityField = (0, $bQWwW.lazy)(()=>(parcelRequire("bICp2")).then((module)=>module.ServiceEntityMain), {
    moduleId: "./src/packages/issue/fields/service-entity/src/ui/main.tsx"
});
const $01bf7c6e3a03bd96$var$AsyncServiceEntityField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "issue-service-entity-field",
        packageName: "issue-service-entity-field",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "field-service-entity",
        packageName: "jira-issue-field-service-entity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "service-entity-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01bf7c6e3a03bd96$var$AsyncLazyServiceEntityField, props))));
var $01bf7c6e3a03bd96$export$2e2bcd8739ae039 = $01bf7c6e3a03bd96$var$AsyncServiceEntityField;

});
parcelRegister("bICp2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("f5PLD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("cahdx")
        ]);
    }),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hXlBG")
]).then(()=>parcelRequire('8deuc'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});




$parcel$global.rlb("a1MLa")
//# sourceMappingURL=async.7c3c346b.js.map
